<template>
    <notifications></notifications>

</template>

<script>
	import notifications from "./Notifications.vue";

	export default {
		name: "notifications_client",
		components: {
			notifications
		},
	};
</script>
